<template>
  <!-- 移动端内容介绍, 纯 UI 组件 -->
  <section class="content-container" v-if="detailList.length">
    <div class="content-title">{{ title }}</div>
    <div class="content-list-container">
      <div class="content-card" v-for="(detailItem, idx) in detailList" :key="idx">
        <div class="card-bg-image">
          <img alt="" :src="detailItem.backgroundImage | img2WebpFilter" />
        </div>
        <div class="card-title">{{ detailItem.title }}</div>
        <div class="card-desc" v-for="(contentItem, idy) in detailItem.content" :key="idy">
          {{ contentItem.paragraph }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    detailList: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="less" scoped>
.content-container {
  box-sizing: border-box;
  padding: 0.6rem 0.16rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #f6f6f6;
  .content-title {
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 600;
    font-size: 0.2rem;
    line-height: 0.28rem;
    display: flex;
    align-items: center;
    text-align: center;
    color: #000000;
    margin-bottom: 0.3rem;
  }
  .content-list-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: stretch;
    .content-card {
      width: 3.43rem;
      min-height: 1.64rem;
      background: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 0.08rem;
      box-sizing: border-box;
      padding: 0.16rem;
      position: relative;
      &:not(:last-child) {
        margin-bottom: 0.2rem;
      }
      .card-bg-image {
        position: absolute;
        right: 0;
        top: 0.16rem;
        width: 0.6rem;
        height: 1.35rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .card-title {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 0.2rem;
        line-height: 0.28rem;
        color: #000000;
        margin-bottom: 0.16rem;
      }
      .card-desc {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 0.14rem;
        line-height: 0.22rem;
        color: rgba(0, 0, 0, 0.6);
        text-align: justify;
        &:not(:last-child) {
          margin-bottom: 0.16rem;
        }
      }
    }
  }
}
</style>
